import { Inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { TrackedAlertEntity } from '../../interfaces/alert-entities/tracked-alert-entity';
import { TrackedAlertEntityForCreation } from '../../interfaces/alert-entities/tracked-alert-entity-for-creation';

// The items a corporation is tracking for alerts (serial numbers, individuals and businesses)
@Injectable({
  providedIn: 'root',
})
export class TrackedAlertEntitiesRepositoryServiceService extends PaginatedRepository<TrackedAlertEntity> {
  protected override _baseLink: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(http, messageService);

    this._baseLinkTemplate = `${config.rootUrl}/Corporations/[0]/Alerts/TrackedEntities`;
    this._baseLink = this._baseLinkTemplate;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }

  private getURL = (corporationID: string) => {
    this.populateBaseLink([corporationID]);
    return this._baseLink;
  }

  // If the corporation already tracks a matching item, the API merges into it (only ever extending its tracking)
  // and returns that item, so the response's end date can differ from the one sent
  public createTrackedEntity = (corporationID: string, newEntity: TrackedAlertEntityForCreation) => {
    return this.http.post<TrackedAlertEntity>(
      this.getURL(corporationID),
      newEntity,
      this.generateHeaders());
  }
}
